import { createContext } from 'react';
import { BakeasyDialogProp } from '../components/dialogs/BakeasyDialog';
import { BakeasyConfirmDialogProp } from '../components/dialogs/BakeasyConfirmDialog';

export interface AppContextPropTypes {
  dialog: BakeasyDialogProp;
  setDialog: React.Dispatch<React.SetStateAction<BakeasyDialogProp>>;
  confirmDialog: BakeasyConfirmDialogProp;
  setConfirmDialog: React.Dispatch<React.SetStateAction<BakeasyConfirmDialogProp>>;
}
export const AppContext = createContext<AppContextPropTypes>({
  dialog: {},
  setDialog: () => {},
  confirmDialog: {},
  setConfirmDialog: () => {}
});
